import { Helmet } from 'react-helmet-async';
import { ServiceStatusList } from '@/components/ServiceStatusList';
import styles from './HealthPage.module.css';

const HealthPage = () => (
  <div className={styles.page}>
    <Helmet>
      <title>Environment Health • AwkHerd</title>
    </Helmet>
    <header className={styles.header}>
      <h1>Environment health</h1>
      <p className={styles.lead}>
        Diagnostic view for verifying supporting services. This route is unpublished.
      </p>
    </header>
    <section className={styles.section} aria-label="Service health checks">
      <ServiceStatusList />
    </section>
  </div>
);

export default HealthPage;
